/**
 * navOpen.js
 * Handles toggling off-screen navigation
 *
 */
export default class navigation {

    constructor() {

        this.settings = {
            navOpen: document.getElementById('navigation-open'),
            navClose: document.getElementById('navigation-close'),
            body: document.getElementsByTagName('body')[0],
            site: document.getElementById('page'),
            activeClass: 'js-nav-open',
            overlayClass: 'js-overlay-active',
            subNav: document.getElementById('subpage-dropdown'),
            subMenuClass: 'js-sub-nav-open',
            subMenuActiveClass: "is-active"
        }

    }

    init() {

        if (null !== this.settings.navOpen) {
            this.bindUIActions();
        }

    }

    bindUIActions() {

        const { navOpen, navClose, subNav } = this.settings;

        // Close mobile menu if screen is resized up
        window.addEventListener('resize', () => {
            if (window.innerWidth > 899) {
                this.navClassSwitcher('remove');
            }
        })

        // Open nav on click on button
        navOpen.addEventListener('click', (e) => {

            this.navClassSwitcher();
        });

        // Close nav on click close button
        navClose.addEventListener('click', (e) => {
            this.navClassSwitcher('remove');
        });

        if (subNav) {

            subNav.querySelector('.subpages__toggle').addEventListener('click', (e) => {
                this.subNavSwitcher(e.target);
            });

        }

    }

    navClassSwitcher(status) {

        const { body, activeClass, subMenuClass, subMenuActiveClass } = this.settings;

        const subMenus = document.querySelectorAll('.navigation__sub-menu');

        if (body.classList.contains(activeClass)) {
            body.classList.remove(activeClass);
            body.classList.remove(subMenuClass);

            subMenus.forEach(menu => {
                menu.classList.remove(subMenuActiveClass);
            })

        } else if ('remove' === status) {
            body.classList.remove(activeClass);
            body.classList.remove(subMenuClass);

            subMenus.forEach(menu => {
                menu.classList.remove(subMenuActiveClass);
            })

        } else {
            body.classList.add(activeClass);
        }

    }

    subNavSwitcher(el) {

        const { activeClass, subNav } = this.settings;

        if (subNav.classList.contains(activeClass)) {
            subNav.classList.remove(activeClass);
            el.setAttribute('aria-expanded', 'false');
        } else {
            subNav.classList.add(activeClass);
            el.setAttribute('aria-expanded', 'true');
        }
    }

}
